// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal__BSdnrUk3XZ{width:600px}.modalEnlarged__ZGDlW3WcEa{width:800px}`, "",{"version":3,"sources":["webpack://./src/app/components/appModals/components/mergeContactsModal/mergeContactsModal.module.scss"],"names":[],"mappings":"AAAA,mBACE,WAAA,CAGF,2BACE,WAAA","sourcesContent":[".modal {\n  width: 600px;\n}\n\n.modalEnlarged {\n  width: 800px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `modal__BSdnrUk3XZ`,
	"modalEnlarged": `modalEnlarged__ZGDlW3WcEa`
};
export default ___CSS_LOADER_EXPORT___;
